import gql from 'graphql-tag';

const VoucherDetailsFragment = gql`
	fragment VoucherDetails on VoucherClass {
		id
		title
		iconName
		description
		price: priceCoins
		maxQuantityPerPerson
		remainingCapacity
		bookableUntil
		redeemableUntil
	}
`;

const VoucherInstanceDetailsFragment = gql`
	fragment VoucherInstanceDetails on VoucherInstance {
		id
		valid
		qrCode
		createdDatetime
		redeemedDatetime
		voucherClass {
			...VoucherDetails
		}
	}
`;

const UserBonusProgramMembershipFragment = gql`
	fragment UserBonusProgramMembership on User {
		id
		active
		name
		bonusProgramMembership(cinemaId: $cinemaId) {
			qrCode
			id
			coinBalance
			ownedVouchers {
				...VoucherInstanceDetails
			}
		}
	}
`;

export const CheckQRCodeQuery = gql`
	query CheckQrCode($qrCode: String!, $cinemaId: ID) {
		user: userByQr(qrCode: $qrCode) {
			...UserBonusProgramMembership
		}
		voucherInstance: voucherInstanceByQR(qrCode: $qrCode) {
			...VoucherInstanceDetails
			user {
				...UserBonusProgramMembership
			}
		}
	}
	${VoucherDetailsFragment}
	${VoucherInstanceDetailsFragment}
	${UserBonusProgramMembershipFragment}
`;

export const TicketCategoriesQuery = gql`
	query TicketCategories($cinemaId: ID!) {
		cinema(id: $cinemaId) {
			id
			ticketCategories: products(categories: [TICKET]) {
				id
				name
				subtext
				bonusPoints
			}
		}
	}
`;

export const CurrentMoviesQuery = gql`
	query CurrentMovies($cinemaId: ID!) {
		cinema(id: $cinemaId) {
			id
			movies(futureOnly: true) {
				id
				title
				poster
			}
		}
	}
`;

export const VoucherCatalogQuery = gql`
	query VoucherCatalog($cinemaId: ID!) {
		cinema(id: $cinemaId) {
			id
			bonusProgram {
				id
				voucherCatalog {
					...VoucherDetails
				}
			}
		}
	}
	${VoucherDetailsFragment}
`;

export const BookTicketBonuspointsMutation = gql`
	mutation BookTicketBonuspoints(
		$amount: Int!
		$userQrCode: String!
		$movieId: ID!
		$groupSize: Int!
	) {
		result: bookCinemaTicketPoints(
			amount: $amount
			userQrCode: $userQrCode
			movieId: $movieId
			groupSize: $groupSize
		) {
			status
		}
	}
`;

export const GetCinema = gql`
	query GetCinema {
		posApp: currentPOS {
			id
			cinemaId
		}
	}
`;

export const LoginMutation = gql`
	mutation Login($authToken: String!) {
		auth: loginPOS(authToken: $authToken) {
			csrf
			posApp {
				id
				cinemaId
			}
		}
	}
`;

export const LogoutMutation = gql`
	mutation Logout {
		logout {
			success
		}
	}
`;

export const BuyAndRedeemVoucherMutation = gql`
	mutation BuyAndRedeemVoucher($voucherClassId: ID!, $userId: ID!) {
		result: buyAndRedeemVoucher(voucherClassId: $voucherClassId, userId: $userId) {
			success
		}
	}
`;

export const RedeemVoucherMutation = gql`
	mutation RedeemVoucher($voucherQR: String!) {
		result: redeemVoucher(voucherQR: $voucherQR) {
			success
		}
	}
`;



// WEBPACK FOOTER //
// ./src/queries.js